module.exports = __webpack_public_path__ + "img/red-x-circle.282de6d2.svg";